import { ADMIN_RESOURCES } from './admin';
import { LOGISTICS_RESOURCES } from './logistics';
import { VENDOR_RESOURCES } from './vendor';
import { getWarehouseResources, WAREHOUSE_RESOURCES } from './warehouse';

const RESOURCES = Object.freeze({
  ADMIN: ADMIN_RESOURCES,
  WAREHOUSE: WAREHOUSE_RESOURCES,
  VENDOR: VENDOR_RESOURCES,
  LOGISTICS: LOGISTICS_RESOURCES,
});

type ResourcesType = keyof typeof RESOURCES;

export const getResources = (key: ResourcesType, isAllFacilities?: boolean) => {
  if (key === 'WAREHOUSE' && isAllFacilities !== undefined) {
    return getWarehouseResources(isAllFacilities);
  }
  return RESOURCES[key];
};
